import { useState } from "react";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import InvoiceTable from "./invoice-table";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function Invoices() {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <ContactSpectrum />
      <Breadcrumb />
      <Box sx={{ ml: 2, mt: 1, display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="h4">Invoices</Typography>
      </Box>

      <Box
        sx={{ mt: 3, mx: 2 }}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="invoices tabs"
          variant="scrollable"
          scrollButtons={false}
        >
          <Tab
            className="tab-label"
            label="TO BE BILLED"
            sx={{
              textTransform: "none",
              fontWeight: value === 0 ? "bold" : "normal",
              color: value === 0 ? "primary.main" : "text.secondary",
              borderBottom: value === 0 ? "2px solid" : "none",
              borderBottomColor: "primary.main",
            }}
          />
          <Tab
            className="tab-label"
            label="CLOSED"
            sx={{
              textTransform: "none",
              fontWeight: value === 1 ? "bold" : "normal",
              color: value === 1 ? "primary.main" : "text.secondary",
              borderBottom: value === 1 ? "2px solid" : "none",
              borderBottomColor: "primary.main",
            }}
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <InvoiceTable isClosed={false} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <InvoiceTable isClosed={true} />
      </CustomTabPanel>
    </>
  );
}
